import { Road } from '../../shared/models/common/road.model';
import { Bound } from '../../shared/models/common/bound.model';
import { Zone } from '../../shared/models/common/zone.model';
import { AssetCode } from '../../shared/models/common/asset-code.model';
import { CatalogAssetCodesGroupDistinctResponse } from '../../shared/models/common/asset-codes-group-distinct.model';
import { Lcca } from '../../shared/models/common/lcca.model';
import { CatalogLccaPeriodicalsResponse } from '../../shared/models/common/lcca-periodical.model';
import { CatalogLccaTriggerResponse } from '../../shared/models/common/lcca-trigger.model';
import { CatalogLccaTypeResponse } from '../../shared/models/common/lcca-type-model';
import { CatalogLccaUnitResponse } from '../../shared/models/common/lcca_unit.model';
import { Result, ResultInitState } from '../../shared/models/core/result.model';

export interface CommonState {
  roadResult: Result<Road>;
  boundResult: Result<Bound>;
  zoneResult: Result<Zone>;
  assetCodeResult: Result<AssetCode>;
  assetCodesGroupDistinctResult: Result<CatalogAssetCodesGroupDistinctResponse>;
  lccaResult: Result<Lcca>;
  lccaPeriodicalResult: Result<CatalogLccaPeriodicalsResponse>;
  lccaTriggerResult: Result<CatalogLccaTriggerResponse>;
  lccaTypeResult: Result<CatalogLccaTypeResponse>;
  lccaUnitResult: Result<CatalogLccaUnitResponse>;
}

export const initialState: CommonState = {
  roadResult: ResultInitState,
  boundResult: ResultInitState,
  zoneResult: ResultInitState,
  assetCodeResult: ResultInitState,
  assetCodesGroupDistinctResult: ResultInitState,
  lccaResult: ResultInitState,
  lccaPeriodicalResult: ResultInitState,
  lccaTriggerResult: ResultInitState,
  lccaTypeResult: ResultInitState,
  lccaUnitResult: ResultInitState,
}
